"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Amplitude = void 0;
const app_1 = require("@koopajs/app");
const AmplitudeCore = require("amplitude-js");
const lodash_1 = require("lodash");
class Amplitude extends app_1.Plugins.Abstract {
    constructor() {
        super();
        this.key = 'amplitude';
        app_1.Bus.onConfigReady(({ amplitude }) => {
            if (lodash_1.isEmpty(amplitude)) {
                return console.warn('Amplitude extension is activated but backend config did not provide a `amplitude` value');
            }
            AmplitudeCore.getInstance().init(amplitude);
            this.dispatchSuccess({});
        });
        app_1.Bus.onUserReady(({ userId }) => {
            AmplitudeCore.getInstance().setUserId(userId);
        });
        app_1.Bus.onAnalytics(({ eventName, args, value }) => {
            AmplitudeCore.getInstance().logEvent(eventName, args);
            if (value) {
                AmplitudeCore.getInstance().logRevenueV2(new AmplitudeCore.Revenue().setPrice(value).setQuantity(1));
            }
        });
    }
}
exports.Amplitude = Amplitude;
//# sourceMappingURL=index.js.map